import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import Button from 'components/Button';
import styles from './index.module.scss';

import { eventsPageActions } from 'containers/Pages/Events';

const PublishEvent = ({ id }) => {
  // selectors--------------
  const approver = useSelector(state => state.user.general);
  // Actions-----------------
  const dispatch = useDispatch();

  const dispatchPublishEvent = useCallback(
    (approver, id) => {
      dispatch(eventsPageActions.approveEvent({ approver, id }));
    },
    [dispatch],
  );

  const publishEvent = () => {
    dispatchPublishEvent(approver, id);
  };

  return (
    <Button
      text="Publish"
      className={styles.button}
      color={'primary'}
      onClick={publishEvent}
    />
  );
};

PublishEvent.propTypes = {
  id: PropTypes.string.isRequired,
};

export default PublishEvent;
